<template>
    <div class="container">
        <!-- <draggable v-model="colors" @update="datadragEnd" :options = "{animation:500}">
            <transition-group>
                <div v-for="element in colors" :key="element.text" class = "drag-item">
                    {{element.text}}
                </div>
            </transition-group>
        </draggable> -->
        <BottomBar :panoInfos="resInfos.panos"></BottomBar>
    </div>
</template>

<script>
// import draggable from 'vuedraggable'
import BottomBar from '../components/webgl/BottomBar.vue'
import https from '../https.js'
export default{
  data() {
    return{
      msg: '这是测试组件',
      colors: [
        {
          text: 'Aquamarine'
        },
        {
          text: 'Hotpink'
        },
        {
          text: 'Gold'
        },
        {
          text: 'Crimson'
        },
        {
          text: 'Blueviolet'
        },
        {
          text: 'Lightblue'
        },
        {
          text: 'Cornflowerblue'
        },
        {
          text: 'Skyblue'
        },
        {
          text: 'Burlywood'
        }
      ],
      startArr: [],
      endArr: [],
      count: 0,
      resInfos: {}
    }
  },
  components: {
    // draggable,
    BottomBar
  },
  created() {
    this.sceneID = this.$route.query.id
    https.fetchPost('/api/HotPoint/GetlistByPyFile_Scene_ID', {
      sceneID: this.sceneID
    }).then(res => {
      if(res.status === 200) {
        var m = {}
        m = res.data.scene
        m.model = res.data.model
        m.panos = []
        for(var i = 0; i < res.data.result.length; i++) {
          var k = {}
          k.physicalFile = res.data.result[i].physicalFile
          k.hotPointlist = res.data.result[i].hotPointlist
          for(var key in res.data.result[i].physicalFile_Scene) {
            k[key] = res.data.result[i].physicalFile_Scene[key]
          }
          m.panos.push(k)
        }
        this.resInfos = m
        console.log(this.resInfos)
      }
    })
  },
  methods: {
    getdata (evt) {
      console.log(evt.draggedContext.element.text)
    },
    datadragEnd (evt) {
      evt.preventDefault()
      console.log('拖动前的索引 :' + evt.oldIndex)
      console.log('拖动后的索引 :' + evt.newIndex)
      console.log(this.colors)
    }
  },
  mounted () {
    //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>

<style scoped>
    /* .test{
        border:1px solid #ccc;
    } */
    .container{
        width: 1200px;
        height:120px;
        position: relative;
    }
    .container>div{
        width: 1200px;
        height:120px;
        position: relative;
    }
    .container>div>span{
        position: relative;
        display: flex;
        -webkit-box-direction: normal;
        -webkit-box-orient: horizontal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        height: 110px;
    }
    .drag-item{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-flow: column nowrap;
        flex-flow: column nowrap;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 70px;
        flex: 0 0 70px;
        position: relative;
        margin-right: 10px;
        margin-left: 10px;
        color: #aaa;
        font-size: 12px;
        background-color: gray;
    }
    /* .ghostClass{
        opacity: 1;
    } */
    /* .bottom{
        width: 200px;
        height: 50px;
        position: relative;
        background: blue;
        top:2px;
        left: 2px;
        transition: all .5s linear;
    } */
</style>
